import { render, staticRenderFns } from "./TotpDetails.vue?vue&type=template&id=d5ea4176&"
import script from "./TotpDetails.vue?vue&type=script&lang=js&"
export * from "./TotpDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports